import { DialogRef } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, interval, map, takeWhile } from 'rxjs';

@Component({
  selector: 'pvd-finalized-orcamento',
  templateUrl: './finalized-orcamento.component.html',
  styleUrls: ['./finalized-orcamento.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FinalizedOrcamentoComponent implements OnInit {
  currentId!: number;
  countdown: number = 5;
  interval: any;
  msg$: Observable<string> | undefined;


  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      orcamentoId: Observable<number>;
    },
    private readonly dialogRef: DialogRef
  ) {}

  ngOnInit(): void {
    this.currentId = this.data as unknown as number;
    history.replaceState({}, '/', `/carrinho`);
    this.msg$ = interval(1000).pipe(
      map(() => this.countdown),
      takeWhile((value) => value >= 0),
      map((count) => `Você será redirecionado automaticamente em ${count} segundos...`)
    );
    this.startCountdown();
  }

  startCountdown() {
    this.interval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.clearIntervalAndNavigate();
      }
    }, 1000);
  }

  clearIntervalAndNavigate() {
    if (this.interval) {
      clearInterval(this.interval);
      this.dialogRef.close();
      this.router.navigate(['produtos']);
    }
  }

  ngOnDestroy(): void {
    this.clearIntervalAndNavigate();
  }

  navigate() {
    clearInterval(this.interval);
    this.dialogRef.close();
    this.router.navigate(['historico-de-vendas/orcamento/orcamento?id='], {
      queryParams: { id: this.currentId },
    });
  }
}
